import Lead1 from "./Lead1.vue";
import Lead2 from "./Lead2.vue";
import Lead3 from "./Lead3.vue";
import Lead4 from "./Lead4.vue";

export const leadQuestions = [
  {
    id: 'recently-diagnosed',
    text: 'I was recently diagnosed',
    component: Lead1,
  },
  {
    id: 'in-treatment',
    text: "I'm currently in treatment",
    component: Lead2,
  },
  {
    id: 'finished-in-remission',
    text: "I've finished treatment and am in remission",
    component: Lead3,
  },
  {
    id: 'long-term-survivor',
    text: "I'm a long-term survivor",
    component: Lead4,
  },
  
  {
    id: 'no-longer-in-treatment',
    text: "I'm not in treatment but still dealing with side effects or symptoms",
    component: Lead4,
  },
  {
    id: 'none-of-these-describe-me',
    text: "None of these describe me",
    component: Lead4,
  },
];